﻿import { TicketVisibility } from '../../enums/index';
import { MessageType } from '../../enums/index';
import { IContact } from '../contact';
import { ITicketMessageFile } from './ticket-message-file';

export interface ITicketMessage {
    id: number;
    ticketId: number;
    parentMessageId: number;
    createdDateTime: string;
    visibility: TicketVisibility;
    subject: string;
    message: string;
    fromEmail: string;
    from: IContact;
    to: IContact[];
    cc: IContact[];
    bcc: IContact[];
    type: MessageType;
    files: ITicketMessageFile[];
    forwardedMessages: any[];
}
